import { ColumnFilterValue } from "@/pages/employees/index/employee-column-filter-conditions.ts";
import {
  ApiEmployeeColumn,
  ApiEmployeeColumnFilter,
  ApiEmployeeColumnFilterType,
} from "@/types/employees/employee-column.types.ts";
import { ReactNode } from "react";

export interface EmployeeColumnFilterValueProps {
  column: ApiEmployeeColumn;
  filter: ApiEmployeeColumnFilter;
  onChange: (value: ColumnFilterValue) => void;
}

/**
 * Свой контрол значения для условия «значение». Подпись колонки и выбор
 * условия рисует поле фильтра, рендер отвечает только за ввод значения.
 */
export type EmployeeColumnFilterValueRenderer = (
  props: EmployeeColumnFilterValueProps
) => ReactNode;

/**
 * Подмена контролов значения: `byColumn` — по ключу колонки каталога
 * (`employee.lifecycle_status`), `byType` — по `filter_type`. Что не задано,
 * рисует контрол по умолчанию (`EmployeeColumnFilterValue`).
 */
export interface EmployeeColumnFilterRenderers {
  byColumn?: Record<string, EmployeeColumnFilterValueRenderer>;
  byType?: Partial<Record<ApiEmployeeColumnFilterType, EmployeeColumnFilterValueRenderer>>;
}

/** Свой рендер для колонки: сначала по ключу, затем по типу фильтра. */
export function resolveEmployeeColumnFilterRenderer(
  column: ApiEmployeeColumn,
  renderers?: EmployeeColumnFilterRenderers
): EmployeeColumnFilterValueRenderer | undefined {
  return renderers?.byColumn?.[column.id] ?? renderers?.byType?.[column.filter_type];
}
